/* eslint-disable */
import * as THREE from 'three'

var s = function (e) {
  return THREE.UniformsUtils.clone(THREE.ShaderLib[e].uniforms)
}

var t = { default: s }

export default t
